import {
  SliderProps,
  Slider as SliderRAC,
  SliderThumb,
  SliderTrack,
} from "react-aria-components";

export default function Slider(props: SliderProps) {
  return (
    <SliderRAC className="w-full" {...props}>
      <SliderTrack className="relative h-7">
        {({ state }) => (
          <>
            <div className="absolute h-1 top-[50%] translate-y-[-50%] w-full rounded-full bg-grey-4/40" />
            <div
              className="absolute h-1 top-[50%] translate-y-[-50%] rounded-full bg-tangerine"
              style={{ width: state.getThumbPercent(0) * 100 + "%" }}
            />
            <SliderThumb className="size-4 top-[50%] rounded-full border-1 border-solid border-tangerine bg-white transition dragging:bg-peach outline-hidden focus-visible:ring-2 ring-black" />
          </>
        )}
      </SliderTrack>
    </SliderRAC>
  );
}
